import React,{ useState, useEffect, useContext }  from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';


import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
//import countryData from './../../assets/countries-states-cities.json';
import birthdataData from './../../assets/birthdate.json';
import userTypedata from './../../assets/user_type.json';
import Autocomplete from '@mui/material/Autocomplete';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { IconButton } from '@mui/material';

import { Auth, API, graphqlOperation } from 'aws-amplify';
import * as queries from '../../graphql/queries';
import bcrypt from 'bcryptjs';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';

import Logo from '../../assets/logo.png';
import loginBanner from '../../assets/mysphere_register.gif';
import otpBanner from '../../assets/otp_verifications.png';
import chooseInterest from "../../assets/Choose_your_interest.png"

import validator from 'validator';
import { useLocation, useNavigate } from 'react-router-dom';
import ParentalConsent from "./ParentalConsent";
import moment from 'moment';
import './Register.css';
import Snackbar from '@mui/material/Snackbar';
//import Alert from '@mui/material/Alert';
import Loader from './../components/Loader';
import Storage from "@aws-amplify/storage";
import { useCookies } from 'react-cookie';

import { addEventLog, getUserInfo } from "./../auth/util/util";
import { UserContext } from '../../App';
import {Helmet} from "react-helmet";
import ReactGA from 'react-ga'; 

import OTPTime from '../../assets/otp_time_exp.svg';
import { useDispatch, useSelector } from 'react-redux';
import { userActions } from '../actions/userActions';
import { alertActions } from '../actions/alertActions';
import { appLink } from './util/CustomConstants.js';
//import './EmailVerification.css';
const salt = bcrypt.genSaltSync(10)


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

// var timeLeft = 30;

// var timerId = setInterval(countdown, 1000);
// var displaytime = 'raja'






function Register(props) {

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [value, setValue] = useState(null);
  const [city, setCity] = useState(null);
  const [userType, setUsertype] = useState(1);
  
  const [country, setCountry] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [birthdate, setBirthdate] = useState('');
  const [gender, setGender] = useState('');
  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState(2010);
  const [firstnameError, setFirstnameError] = useState('');
  const [lastnameError, setLastnameError] = useState('');
  const [genderError, setgenderError] = useState('');
  const [birthdateError, setBirthdateError] = useState('');
  
  const [emailOTP, setEmailOTP] = useState('');
  const [emailError, setEmailError] = useState('');
  const [mobileError, setMobileError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [cityError, setCityError] = useState('');
  const [countryError, setCountryError] = useState('');
  const [stateError, setStateError] = useState('');
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [userAge, setUserAge] = useState('');
  const [gardianNameError, setGardianNameError] = useState('');
  const [gardianEmailError, setGardianEmailError] = useState('');
  const [gardianMobileError, setGardianMobileError] = useState('');
  const [gardianCheck, setGardianCheck] = useState(true);
  const [gardianCheckError, setGardianCheckError] = useState('');
  const [selCountry, setSelCountry] = useState(null);
  const [selState, setSelState] = useState(null);
  const [referralcode, setReferralcode] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [viewEmail, setViewEmail] = useState(true);
  const [viewMobile, setViewMobile] = useState(true);
  const [success, setSuccess] = useState(false);
  const [failed, setFailed] = useState(false);
  const [skipMobile, setskipMobile] = useState(true);
  const [failedMsg, setFailedMsg] = useState('Something went wrong! Please try later.');
  const [values, setValues] = React.useState({
    password: "",
    showPassword: false,
    confirmPassword: "",
    showConfirmPassword: false,
  });
  const [showRegScreen, setShowRegScreen] = useState(true);
  const [showOtpScreen, setShowOtpScreen] = useState(false);
  const [showParentalScreen, setShowParentalScreen] = useState(false);
  const [emailOTPError, setEmailOTPError] = useState('');
  const [mobileOTPError, setMobileOTPError] = useState('');
  const [timeLeft, settimeLeft] = useState(60);
  const [timerId, settimerId] = useState(null);
  const [displaytime, setdisplaytime] = useState('');
  const [seconds, setSeconds] = useState(null);
  const [secondsEmail, setEmailSeconds] = useState(false);

  const [seconds_mobile, setSeconds_mobile] = useState(null);
  const [secondsISmobile, setmobileSeconds] = useState(false);
  const [openTost, setOpenTost] = React.useState(false);
  const [Tost_msg, setTost_msg] = useState('This is a success message!');
  
  const [socialEmail, setSocialEmail] = React.useState('');
  const [showLoader, setShowLoader] = useState(false);

  const [cookies, setCookie, removeCookie] = useCookies(['access_token', 'userDetails']);
  const [countryData,setCountryData] = useState([]);
  const profileContext = useContext(UserContext);
  const [logid, setLogid] = useState(0);
  const [refImage, setRefImage] = useState(null)
  const [refMessage, setRefMessage] = useState(null)
  
  let navigate = useNavigate();
  let expires = new Date()
  expires.setTime(expires.getTime() + (86400*1000))

  const dispatch = useDispatch();
  const authenticationState = useSelector(state => state.authenticationState);
  const alertMsg = useSelector(state => state.alertState);

  useEffect(()=>{
    if(queryParams.get('ref') === "interest_home"){
      setRefImage(chooseInterest)
      setRefMessage("Select your interests, and get customised content on career options, learning paths to grow your skills, quizzes and more.")
    }else{
      setRefImage(loginBanner)
      setRefMessage("MySphere can lay the foundation for your career by helping you build a strong profile, digital portfolio and dynamic CV along with guidance on career paths suited to your skills and interests.")
    } 

    console.log("birthdataData",birthdataData);
    const initiateFun = async() => {
      ReactGA.pageview(window.location.pathname);
      if(authenticationState.loggedIn==true)
      {
        dispatch(userActions.logout()); 
        removeCookie('access_token',{ path: '/',domain:'.mysphere.net'})
        removeCookie('userDetails',{ path: '/',domain:'.mysphere.net'})
        await Auth.signOut();
      }
      dispatch(alertActions.clear())
      fetch(process.env.PUBLIC_URL+`/countries-states-cities.json`)
      .then(response => response.json())
      .then(data => {
        console.log(data);
        setCountryData(data)
        setCountryCode(data[102].phone_code);
        console.log("===>",data[102]);
        Object.keys(data[102]).forEach(function(key) {
 
          if(data[102]["phone_code"].includes("+")===false)
          {
            data[102]["phone_code"] = "+"+data[102]["phone_code"]
          }
           ;
          
         });

        setSelCountry(data[102]);
        setStateList(data[102].states);
        setCityList([]);
        
      })
     // console.log('gender123',gender)
      //alert(profileContext.state.underAge)
      let settingQuery=await API.graphql(graphqlOperation(queries.listSettings,{limit:10000}));
      let settingData=settingQuery.data.listSettings.items.filter(item => item._deleted !== true);
      
      console.log('settingData',settingData);
      for (let i = 0; i < settingData.length; i++) {
        const element = settingData[i];
        if(element.module=='aboveAge')
        {
          profileContext.dispatch({type:'updateAboveAge', payload: element.setting});
        }
        if(element.module=='underAge')
        {
          profileContext.dispatch({type:'updateUnderAge', payload: element.setting});
        }
      }
  
      let socialEmailLoc=localStorage.getItem('socialEmail');
      
      if(socialEmailLoc)
      {
        setSocialEmail(socialEmailLoc);
        setEmail(socialEmailLoc)
        console.log('socialEmailLoc',socialEmailLoc)
      }
  
  
      addEventLog(0,0,'b7da3507-d19b-43fe-a199-8701b39413ca','','');
  
      
    }
    initiateFun();  
    
  },[]);

  useEffect(() => {
    var timer1;
    if (seconds > 0) {
      timer1=  setTimeout(() => setSeconds(seconds - 1), 1000);
      setEmailSeconds(false)
    } else {
    //  clearTimeout(timer1);
      setSeconds('');
      setEmailSeconds(true)
     
    }

    return () => {
      clearTimeout(timer1);
    };
  },[setSeconds,seconds]);


  useEffect(() => {
    var timer1;
   
    //if (seconds > 0) {
      timer1=  setTimeout(() => setSeconds(60 - 1), 1000);
      setEmailSeconds(false)
    // } else {
    // //  clearTimeout(timer1);
    //   setSeconds('');
    //   setEmailSeconds(true)
     
    // }

    return () => {
      clearTimeout(timer1);
    };
  },[authenticationState.firstStep]);


  useEffect(() => {
    if(authenticationState.emailOTPError!='')
    {
      setEmailOTPError(authenticationState.emailOTPError);
    }
  },[authenticationState.emailOTPError]);

  useEffect(() => {
    if(authenticationState.userData && Object.keys(authenticationState.userData).length != 0)
    {
      if(authenticationState.isParental===true)
      {
        navigate(process.env.PUBLIC_URL+"/success/parentialThanks");
        setSuccess(true)
        setFailed(false)
      }
      if(authenticationState.isParental===false)
      {
        navigate(process.env.PUBLIC_URL+"/success/studentThanks");
        setSuccess(true)
        setFailed(false)
      }
    }
  },[authenticationState.registerDone]);

  useEffect(() => {
    var timer2;
    if (seconds_mobile > 0) {
      timer2= setTimeout(() => setSeconds_mobile(seconds_mobile - 1), 1000);
      setmobileSeconds(false)
    } else {
      clearTimeout(timer2);
      setSeconds_mobile('');
      setmobileSeconds(true)
     
    }


    return () => {
      clearTimeout(timer2);
    };
  },[setSeconds_mobile,seconds_mobile]);



  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClickShowConfirmPassword = () => {
    setValues({ ...values, showConfirmPassword: !values.showConfirmPassword });
  };
  
  const handleMouseDownConfirmPassword = (event) => {
    event.preventDefault();
  };
  
  const handleChangeCountry = (event) => {
    if(event)
    {
      setCountry(event.name);
      // let cities = countryData.find((item)=>item.id===event.target.value);
      setStateList(event.states);
      //setCityList(event.cities);
      setCountryCode(event.phone_code);
      setSelCountry(event);
    }
    else
    {
      setCountry('');
      setStateList([]);
      setCityList([]);
    }
  };
  
  const handleChangeState = (event) => {
    if(event)
    {
      console.log(event);
      setSelState(event);
      setCityList(event.cities);
    }
    else
    {
      setStateList([]);
      setCityList([]);
    }
  };

  const handleChangeCity = (event) => {
    console.log('setCity' ,event)
    setCity(event);
  };


  const handleChangeCountryCode = (event) => {
    console.log("event==>",event.phone_code);
    setCountryCode(event.phone_code.replaceAll('+',''));
   console.log("event.phone_code==>***",event.phone_code.replaceAll('+',''));
    Object.keys(event).forEach(function(key) {
  
     if(event.phone_code.includes("+")===false)
     {
       event.phone_code = "+"+event.phone_code
     }
      ;
     
    });
    setSelCountry(event);
   };

  const getAge = (dateString) => {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
    {
        age--;
    }
    return age;
  }

  const sendOTP = async(email,mobile,register,social_login,resent) => {
    setShowLoader(true)

    const apiName = 'welcomeemaildev';
    const path = '/sendemailnsms';
    const myInit = {
      body: {
      "email": email.toLowerCase(),
      "mobile_no": mobile,
      "register" : register,
      "social_login" : social_login,
      "resent" : resent,
      "country_code":countryCode
      }
    };

    await API.post(apiName, path, myInit)
      .then((response) => {
        addEventLog(0,0,'b7da3507-d19b-43fe-a199-8701b39413ca',mobile,email);
        setShowLoader(false);
        //response.text()
      })
      .catch((error) => {
        setShowLoader(false);
        console.log('error', error);
      });
    // var myHeaders = new Headers();
    // myHeaders.append("Content-Type", "application/json");

    // var raw = JSON.stringify({
    //   "email": email.toLowerCase(),
    //   "mobile_no": mobile,
    //   "register" : register,
    //   "social_login" : social_login,
    //   "resent" : resent,
    //   "country_code":countryCode
    // });

    // var requestOptions = {
    //   method: 'POST',
    //   headers: myHeaders,
    //   body: raw,
    //   redirect: 'follow'
    // };

    // fetch("https://lg6qtrhsf5.execute-api.ap-south-1.amazonaws.com/sendemailnsms", requestOptions)
    //   .then(response => {
    //     addEventLog(0,0,'b7da3507-d19b-43fe-a199-8701b39413ca',mobile,email);
    //     setShowLoader(false);
    //     response.text()
    //   }
    //    )
    //   .then(result => console.log(result))
    //   .catch(error =>{
    //     setShowLoader(false);
    //     console.log('error', error)
    //   } );
    
  }

  useEffect(() => {
    
    if(authenticationState.showOtpScreen==true)
    {
      let utype = userTypedata.find((item)=>item.id===userType);
      const hashedPassword = bcrypt.hashSync(password, salt)
      var sendData={
        "email": email,
        "otp_email": '',
        "otp_mobile": '',
        "mobile_no": mobile,
        "name": firstname + ' '+ lastname,
        "first_name": firstname ,
        "last_name": lastname,
        "gender":gender,
        "birthdate":formatDate(birthdate),
        "birthdate_new":birthdate,
        "usertype":"student",
        "referralcode":referralcode,
        // "country":selCountry.name,
        // "state":selState.name,
        // "city":city.name,
        "country":'',
        "state":'',
        "city":'',
        "logid":authenticationState.logid,
        "hashedPassword":hashedPassword,
        "password":password,
        "countryCode":countryCode,
        "userAge":userAge,
        "underAge":profileContext.state.underAge,
       
        "userDetailsData":{ first_name:firstname, last_name: lastname, dob:moment(value).format('YYYY-MM-DD'),gender: gender,profile_avatar:gender,about_restriction:1,mobile_no:mobile,userType:1,referralCode:referralcode,country:0,state:0,city:0,skipMobileVerification:skipMobile,countryCode:countryCode }
      }
      dispatch(userActions.finalRegister(sendData));
    }
  },[authenticationState.showOtpScreen]);


  
  var newdobValue='';
  const formValidate = (data) => {
    console.log('data ',data)
    let firstnameError = "";
    let lastnameError = "";
    let birthdateError = "";
    let emailError = "";
    let genderError2 = "";
    let mobileError = "";
    let passwordError = "";
    let cityError = "";
    let stateError = "";
    let countryError = "";
    let gardianNameError = "";
    let gardianEmailError = "";
    let gardianMobileError = "";
    let gardianCheckError = "";
    let confirmPasswordError = "";

    const regMatchFirst = /^[a-zA-Z ]*$/.test(data.get('firstName'));
    const regMatchLast = /^[a-zA-Z ]*$/.test(data.get('lastName'));
    let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


    if (data.get('firstName')=='') {
      firstnameError = "Please enter your first name";
      document.getElementById('firstName').focus();
    }
    else if(!regMatchFirst)
    {
      firstnameError = "Please enter a valid first name";
      document.getElementById('firstName').focus();
    }
    else
    {
      firstnameError = "";
    }
    console.log('lastName',data.get('lastName'));
    if (data.get('lastName')=='') {
      lastnameError = "Please enter your last name";
      document.getElementById('lastName').focus();
    }
    else if(!regMatchLast)
    {
      lastnameError = "Please enter a valid last name";
      document.getElementById('lastName').focus();
    }
    else
    {
      lastnameError = "";
    }

console.log('gender q',data.get('gender'));
    if (data.get('gender')=='') {
      genderError2 = "Please select gender";
      document.getElementById('gender').focus();
    }else{
      genderError2 = "";
    }
    // if (data.get('birthdate')=='') {
    //   birthdateError = "Please enter your birth date";
    // }
    // else if (userAge < profileContext.state.aboveAge) {
    //   birthdateError = "You are below the minimum age that is required to sign up";
    // }
    // else
    // {
    //   birthdateError="";
    // }
    if (data.get('day')=='') {
      birthdateError = "Please select your birth day";
    }
    else if (data.get('month')=='') {
      birthdateError = "Please select your birth month";
    }
    else if (data.get('year')=='') {
      birthdateError = "Please select your birth year";
    }
    // else if (userAge < profileContext.state.aboveAge) {
    //   birthdateError = "You are below the minimum age that is required to sign up";
    // }
    else
    {
      console.log("dateselect==>",data.get('year')+'/'+data.get('month')+'/'+data.get('day'));
       newdobValue=new Date(data.get('year')+'/'+data.get('month')+'/'+data.get('day'));
      console.log("birthdateregisterregister",newdobValue);
      setValue(newdobValue);
      let age=getAge(newdobValue);
      console.log(age);
      setUserAge(age);
      if (age < profileContext.state.aboveAge) {
          birthdateError = "You are below the minimum age that is required to sign up";
        }
        else
        {
          birthdateError="";
        }
      
    }

    if (data.get('email')=='') {
      emailError = "Please enter a valid email address";
      document.getElementById('email').focus();
    }
    else if(!regEmail.test(data.get('email')))
    {
      emailError = "Please enter a valid email address";
      document.getElementById('email').focus();
    }
    else
    {
      emailError = "";
    }
    
    if (data.get('mobile')=='') {
      mobileError = "Please enter a mobile number";
      document.getElementById('mobile').focus();
    }
    else if(!/^[0-9\b]+$/.test(data.get('mobile')) || data.get('mobile').length < 8)
    {
      mobileError = "Please enter a valid mobile number";
      document.getElementById('mobile').focus();
    }
    else
    {
      mobileError = "";
    }

    if (data.get('password').trim()=='') {
      passwordError = "Please enter your password";
      document.getElementById('password').focus();
    }
    else if(data.get('password').length < 8)
    {
      passwordError = "Please enter at least 8 characters";
    }
    // else if (validator.isStrongPassword(data.get('password').trim(), {
    //   minLength: 8, minLowercase: 1,
    //   minUppercase: 1, minNumbers: 1, minSymbols: 1
    // })) {
    //   passwordError = "";
    // } 
    // else {
    //   if(isUpperCase(data.get('password').trim())===false)
    //   {
    //     passwordError = "Your password must include one uppercase";
    //   }
    //    else if(isSpecialCase(data.get('password').trim())===false)
    //   {
    //     passwordError = "Your password must include one special character";
    //   }
    //   else if(isContainsNumber(data.get('password').trim())===false)
    //   {
    //     passwordError = "Your password must include one number";
    //   }
    //   else
    //   {
    //   passwordError = "This is not a strong password";
    //   }
    //   document.getElementById('password').focus();
    // }
   

    if (data.get('confirmpassword').trim()=='') {
      confirmPasswordError = "Please confirm your password";
      document.getElementById('confirmpassword').focus();
      
    }
    else if(data.get('confirmpassword').length < 8)
    {
      confirmPasswordError = "Please enter at least 8 characters";
      document.getElementById('confirmpassword').focus();
    }
    // else if (validator.isStrongPassword(data.get('confirmpassword').trim(), {
    //   minLength: 8, minLowercase: 1,
    //   minUppercase: 1, minNumbers: 1, minSymbols: 1
    // })) 
    // {
    //   confirmPasswordError = "";
    // }
    //  else {
      
    //   if(isUpperCase(data.get('confirmpassword').trim())===false)
    //   {
    //     confirmPasswordError = "Your password must include one uppercase";
    //   }
    //    else if(isSpecialCase(data.get('confirmpassword').trim())===false)
    //   {
    //     confirmPasswordError = "Your password must include one special character";
    //   }
    //   else if(isContainsNumber(data.get('confirmpassword').trim())===false)
    //   {
    //     confirmPasswordError = "Your password must include one number";
    //   }
    //   else
    //   {
    //     confirmPasswordError = "This is not a strong password";
    //   }

     
    //   document.getElementById('confirmpassword').focus();
    // }
    if (data.get('password').trim() != data.get('confirmpassword').trim()) {
      confirmPasswordError = "Password and Confirm password does not match";
      document.getElementById('confirmpassword').focus();
    }
    

    // if (data.get('city')=='') {
    //   cityError = "Please select a city";
    // }
    // else
    // {
    //   cityError = "";
    // }
    
    
    // if (data.get('state')=='') {
    //   stateError = "Please select a State";
    // }
    // else
    // {
    //   stateError = "";
    // }


    // if (data.get('country')=='') {
    //   countryError = "Please select a country";
    // }
    // else
    // {
    //   countryError='';
    // }



    if (firstnameError || lastnameError || genderError2 || birthdateError || emailError || mobileError || passwordError || cityError || countryError || stateError || gardianNameError || gardianEmailError || gardianMobileError || gardianCheckError || confirmPasswordError) {
      setFirstnameError(firstnameError);
      setLastnameError(lastnameError);
      setBirthdateError(birthdateError);
      setEmailError(emailError);
      setgenderError(genderError2);
    //  console.log('genderError', genderError)
      
      setMobileError(mobileError);
      setPasswordError(passwordError);
      setConfirmPasswordError(confirmPasswordError);
      setCityError(cityError);
      setStateError(stateError);
      setCountryError(countryError);
      setGardianNameError(gardianNameError);
      setGardianEmailError(gardianEmailError);
      setGardianMobileError(gardianMobileError);
      setGardianCheckError(gardianCheckError);
      return false;
    }
    else {
      setFirstnameError('');
      setLastnameError('');
      setBirthdateError('');
      setEmailError('');
      setgenderError('');
      setMobileError('');
      setPasswordError('');
      setCityError('');
      setStateError('');
      setCountryError('');
      setGardianNameError('');
      setGardianEmailError('');
      setGardianMobileError('');
      setGardianCheckError('');
      setConfirmPasswordError('');
    }

    return true;
  }
  const isUpperCase = (string1) =>{
    console.log("string==>",string1);
    return /[A-Z]/.test(string1);
  } 
  const isSpecialCase = (string) => 
  {
    var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    return format.test(string);
  } 
  const isContainsNumber = (string1) =>{
    console.log("string==>",string1);
    return /\d/.test(string1);
  } 
  
  const handleSubmit = async(event) => {
    event.preventDefault();

    const data = new FormData(event.currentTarget);
    //console.log("data===>",data); return false;
    let isValid = formValidate(data);
    
    if (isValid) {
      
      // var setdob=new Date(data.get('day')+'/'+data.get('month')+'/'+data.get('year'));
      var setdob=data.get('day')+'/'+data.get('month')+'/'+data.get('year');
      setFirstname(data.get('firstName'))
      setLastname(data.get('lastName'))
      setBirthdate(setdob)
      setGender(data.get('gender'))
      setPassword(data.get('password'))
      
      let socialEmailLoc=localStorage.getItem('socialEmail');
      if(socialEmailLoc)
      {
         let utype = userTypedata.find((item)=>item.id===userType);
        var sendData={
          // 'city':city.id,
          // 'country':selCountry.id,
          // 'state':selState.id,
          'city':0,
          'country':0,
          'state':0,
          'dob':newdobValue,
          'userAge':userAge,
          'underAge':profileContext.state.underAge,
          "usertype":1,

        }
       // "userAge":userAge,
        //"underAge":profileContext.state.underAge,
        dispatch(userActions.socialRegistration(data,sendData));
      }
      else
      {
        //dispatch(userActions.register(data,city.id,selCountry.id,selState.id,value));
        dispatch(userActions.register(data,0,0,0,newdobValue));
      }
    
     


    }
  };



 function formatDate(date) {
  var newdate = date.split("/").reverse().join("/");
   console.log('date==>',newdate);
   var d = new Date(newdate),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    console.log("finaldate",[year, month, day].join('-'));
    return [year, month, day].join('-');
}




 const handleSubmitOtp = (event) => {
  event.preventDefault();
  

  const data = new FormData(event.currentTarget);
  let isValid = formValidateOtp(data);
    
    if (isValid) {
 
      let utype = userTypedata.find((item)=>item.id===userType);
      const hashedPassword = bcrypt.hashSync(password, salt)
      var sendData={
        "email": email,
        "otp_email": data.get('emailOTP'),
        "otp_mobile": data.get('mobileOTP'),
        "mobile_no": mobile,
        "name": firstname + ' '+ lastname,
        "first_name": firstname ,
        "last_name": lastname,
        "gender":gender,
        "birthdate":formatDate(birthdate),
        "birthdate_new":birthdate,
        "usertype":"student",
        "referralcode":referralcode,
        // "country":selCountry.name,
        // "state":selState.name,
        // "city":city.name,
        "country":'',
        "state":'',
        "city":'',
        "logid":authenticationState.logid,
        "hashedPassword":hashedPassword,
        "password":password,
        "countryCode":countryCode,
        "userAge":userAge,
        "underAge":profileContext.state.underAge,
       
        "userDetailsData":{ first_name:firstname, last_name: lastname, dob:moment(value).format('YYYY-MM-DD'),gender: gender,profile_avatar:gender,about_restriction:1,mobile_no:mobile,userType:1,referralCode:referralcode,country:0,state:0,city:0,skipMobileVerification:skipMobile,countryCode:countryCode }
      }
      console.log("sendData==>",sendData);
      dispatch(userActions.finalRegister(sendData));
    }
 }

 
 const formValidateOtp = (data) => {
  let emailOTPError = "";
  let mobileOTPError = "";

  if(socialEmail=='')
  {
  
    if (data.get('emailOTP')=='') {
    
      emailOTPError = "Please enter the OTP";
    }
    else if (validator.isInt(data.get('emailOTP'))&& validator.isLength(data.get('emailOTP'),{min:6,max:6}))
    {
     
      emailOTPError = "";
    }
    else
    {
     
      emailOTPError = "Please enter a valid OTP";
    }
  }

  

 // if (emailOTPError || mobileOTPError) {
    if (emailOTPError) {
    setEmailOTPError(emailOTPError);
   // setMobileOTPError(mobileOTPError);
    
    return false;
  }
  else {
    setEmailOTPError('');
    setMobileOTPError('');
   
  }

  return true;
}


  const handleSubmitParental = (parentName,parentEmail,parentMobile,skipParental) => {
    console.log(parentName)
    console.log(parentEmail)
    console.log(parentMobile)
    console.log(skipParental)


    
    const hashedPassword = bcrypt.hashSync(password, salt)
    var sendData={
      "email": email,
      "mobile_no": mobile,
      "name": firstname + ' '+ lastname,
      "first_name": firstname ,
      "last_name": lastname,
      "gender":gender,
      "birthdate":formatDate(birthdate),
      "birthdate_new":birthdate,
      "usertype":userType,
      "referralcode":referralcode,
      "country":selCountry.name,
      "state":selState.name,
      "city":city.name,
      "logid":authenticationState.logid,
      "hashedPassword":hashedPassword,
      "password":password,
      "countryCode":countryCode,
      "parent_name":parentName,
      "parent_email":parentEmail.toLowerCase(),
      "parent_mobile":parentMobile,
      

      "userDetailsData":{ first_name:firstname, last_name: lastname, dob:moment(value).format('YYYY-MM-DD'),gender: gender,profile_avatar:gender,about_restriction:1,mobile_no:`+${countryCode}${mobile}`,userType:userType,referralCode:referralcode,country:selCountry.id,state:selState.id,city:city.id,skipParentalconsent:skipParental,skipMobileVerification:skipMobile }
    }


    dispatch(userActions.parentalRegister(sendData))

       
  }

  const checkUsername = async(username1) => {
    let username= username1.replace( / +/g, '');
    const userData = await API.graphql(graphqlOperation(queries.listUserProfileDetails,{filter: {username: {eq: username}},limit:500}));
    const items=userData.data.listUserProfileDetails.items;
    let newData=items.filter(item => item._deleted !== true);
    if(newData.length > 0)
    {
      return checkUsername(username+newData.length)
    }
    else
    {
      return username
    }
  }


  const goBackRegistration = () => {
    
    setValues('');
    dispatch(userActions.resertRegister());
    setShowRegScreen(true);
    setShowOtpScreen(false);
    setShowParentalScreen(false);
    setSeconds(0)
    setSeconds_mobile(0)
    setSeconds(60)
    setEmailSeconds(false);

    setSeconds_mobile(60)
    setmobileSeconds(false);
  }
 

  const goBackOTP = () => {
    setSeconds(0)
    setSeconds_mobile(0)
    setSeconds(60)
    setEmailSeconds(false);

    setSeconds_mobile(60)
    setmobileSeconds(false);

    // setShowRegScreen(false);
    // setShowOtpScreen(true);
    // setShowParentalScreen(false);
  }

  const resend_Email_otp= () => {
    setSeconds(60)
    setEmailSeconds(false);

    //sendOTP(email,mobile,socialEmail=='' ? true : false,socialEmail=='' ? false : true,'email');
    dispatch(userActions.sendEmailOTP(email,mobile,socialEmail=='' ? true : false,socialEmail=='' ? false : true,'email',countryCode));
    
  }

  const resend_mobile_otp= () => {
    setSeconds_mobile(60)
    setmobileSeconds(false)
    //sendOTP(email,mobile,socialEmail=='' ? true : false,socialEmail=='' ? false : true,'mobile');
    dispatch(userActions.sendOTP(email,mobile,socialEmail=='' ? true : false,socialEmail=='' ? false : true,'mobile',countryCode));
  }

      
  const handleClickTost = () => { setOpenTost(true);};

  const handleCloseTost = (event, reason) => {
      if (reason === 'clickaway') {
      return;
      }
      setOpenTost(false);
  };  


     

  return (
    <body className='loginPageBody'>
    <div className='custom_container register-box'>
    <Helmet>
      <meta charSet="utf-8" />
      <title>Create account on MySphere</title>
      <meta
        name="description"
        content="Student Digital Portfolio, CV Building and Career Guidance Platform - MySphere"
      />
      <script type="text/javascript">
        {`
          (function() {
          window.__insp = window.__insp || [];
          __insp.push(['wid', 804507840]);
          var ldinsp = function(){
          if(typeof window.__inspld != "undefined") return; window.__inspld = 1; var insp = document.createElement('script'); insp.type = 'text/javascript'; insp.async = true; insp.id = "inspsync"; insp.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://cdn.inspectlet.com/inspectlet.js?wid=804507840&r=' + Math.floor(new Date().getTime()/3600000); var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(insp, x); };
          setTimeout(ldinsp, 0);
          })();
          `}
          </script>
    </Helmet>
    <Loader visible={showLoader} />
       <Stack spacing={2} sx={{ width: '100%' }}>
                {/* <Button variant="outlined" onClick={handleClickTost}>
                    Open success snackbar
                </Button> */}
                <Snackbar open={openTost} autoHideDuration={6000} onClose={handleCloseTost}>
                    <Alert onClose={handleCloseTost} severity="success" sx={{ width: '100%' }}>
                    {Tost_msg}
                    </Alert>
                </Snackbar>
            
            </Stack>
      {/* <p>{seconds}</p> */}

      {/* Register Page */}
      {authenticationState.showRegScreen===true &&
          <Grid container spacing={2} className='loginScreen'>
            <Grid item md={6} className='formsection'>
              <Box component="form" noValidate onSubmit={handleSubmit}>
              <Link href={appLink} ><img src={Logo} title="MySphere" alt='MySphere' className='logo2'/></Link> 
              <Grid item xs={12}>
                  {/* <Stack sx={{ width: '100%' }} spacing={2}>
                  {failed === true &&
                    <Alert severity="error">
                      <AlertTitle>Error</AlertTitle>
                      {failedMsg}
                    </Alert>
                  }
                  
                  </Stack> */}
                  <Stack sx={{ width: '100%' }} spacing={2}>
                    {alertMsg.message &&
                      <Alert severity={`${alertMsg.type}`}>
                        <AlertTitle style={{textTransform: 'capitalize'}}>{alertMsg.type}</AlertTitle>
                        {alertMsg.message}
                      </Alert>
                    }              
                </Stack>
                </Grid>             
              <Grid container className='forgot_or_register_option'>
                <Grid item md={5}><h1>Sign up</h1></Grid>
                <Grid item md={7}><p>Already have an account? <Link href={`${process.env.PUBLIC_URL}/signin`}>Sign in</Link></p></Grid>
              </Grid>
              
              <Grid container spacing={3}>
                <Grid item md={6} >
                  <FormControl fullWidth className='formControl'>
                    <label>First name*</label>
                    <TextField

                        autoComplete="none"
                        name="firstName"
                        required
                        fullWidth
                        id="firstName"
                        autoFocus
                        helperText={firstnameError}
                        error={!!firstnameError}
                        value={firstname}
                        onChange={(event)=>setFirstname(event.target.value)}
                    
                      />
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  <FormControl fullWidth className='formControl'>
                    <label>Last name*</label>
                    <TextField
                      required
                      autoComplete="none"
                      fullWidth
                      id="lastName"
                      name="lastName"
                      helperText={lastnameError}
                      error={!!lastnameError}
                      value={lastname}
                      onChange={(event)=>setLastname(event.target.value)}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  <FormControl fullWidth className='formControl'>
                    <label>Email*</label>
                      {/* // autoComplete="email" */}
                    <TextField
                      autoComplete="none"
                      required
                      fullWidth
                      id="email"
                      name="email"
                      type="email"
                      InputProps={{
                        readOnly:socialEmail =='' ? false : true
                      }}
                      helperText={emailError}
                      error={!!emailError}
                      value={email}
                      onChange={(event)=>setEmail(event.target.value)}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  <FormControl fullWidth className='formControl'>
                    <label>Mobile number*</label>
                    <div className="mobile_box">
                      {/* <Select className='mobile_code'
                        autoComplete="none"
                          labelId="demo-simple-select-autowidth-label"
                          id="demo-simple-select-autowidth"
                          name={'countryCode'}
                          value={countryCode}
                          onChange={handleChangeCountryCode}
                          autoWidth
                        >
                          
                          {countryData.map((item) =>
                          <MenuItem key={item.phone_code} value={item.phone_code}>+{item.phone_code}</MenuItem>
                          )}
                        </Select> */}

                        <Autocomplete
                        className='mobile_code'
                        id="country-select-demo"
                        sx={{ width: 80 }}
                                           
                      
                        value={selCountry}
                        options={countryData}
                        autoHighlight
                        disableClearable
                        getOptionLabel={(option) => option.phone_code}
                        onChange={(event, newValue) => {
                          handleChangeCountryCode(newValue);
                        }}
                      
                   
                        renderOption={(props, option) => (
                          <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props} >
                            {option.emoji}&nbsp;&nbsp; (+{option.phone_code}) {option.name}

                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder='+91'
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'new-password', // disable autocomplete and autofill
                            }}
                            error={!!countryError}
                            id="countryCode"
                            name="countryCode"
                          />
                        )}
                      />
                      <TextField className='mobile_code_number'
                        autoComplete="none"
                        required
                        fullWidth
                        id="mobile"
                        name="mobile"
                        type="tel"
                        helperText={mobileError}
                        error={!!mobileError}
                        InputProps={{
                          
                          inputMode: 'numeric', pattern: '[0-9]*'
                        }}
                        value={mobile}
                        onChange={(event)=>setMobile(event.target.value)}
                      />
                    </div>
                  </FormControl>
                </Grid>
              <Grid item md={12} className='dob_parts'>
                <Grid container columnSpacing={{ xs: 0, sm: 0, md: 3 }}>
                  <Grid item md={12}>
                    <FormControl fullWidth className='formControl dob_label'>
                      <label>Date of birth*</label>
                    </FormControl>
                  </Grid>
                  <Grid item md={4}>
                    <FormControl fullWidth className='formControl dob_input'>
                      {/* <label>Date</label> */}
                      {/* <LocalizationProvider dateAdapter={AdapterDateFns} className="w-100" >
                      <DatePicker
                          allowSameDateSelection
                          disableFuture
                          value={value}
                          inputFormat={'dd/MM/yyyy'}
                          openTo="year"
                          views={['year', 'month', 'day']}
                          onChange={(newValue) => {
                            setValue(newValue);
                            console.log('birthday',newValue)
                            console.log('Age',getAge(newValue));
                            setUserAge(getAge(newValue))
                          }}
                          errorText={birthdateError}
                          inputProps={{ readOnly: true,placeholder:"" }}
                          // error={!!birthdateError}
                          renderInput={(params) => <TextField {...params} name="birthdate" id="birthdate" error={!!birthdateError}  />}
                      />
                      </LocalizationProvider> */}
                      <Select labelId="demo-simple-select-helper-label" className='dob_select_dropdown'
                        id="day"
                        name="day"
                        value={day}
                        displayEmpty
                        onChange={(event)=>setDay(event.target.value)}
                        autoWidth
                        MenuProps={MenuProps}
                      >
                        <MenuItem  value='' disabled><Typography variant="p">Day</Typography></MenuItem>
                        {birthdataData[0]['day'].map((item) =>
                        <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                      )}  
                      </Select>
                      {/* {!!birthdateError &&
                      // <p className="error_msg">{birthdateError}</p> 
                      <FormHelperText className="Mui-error">{birthdateError}</FormHelperText>
                      } */}
                    </FormControl>
                    </Grid>
                  <Grid item md={4}>
                  <FormControl fullWidth className='formControl dob_input'>
                    {/* <label>Month*</label> */}
                  <Select labelId="demo-simple-select-helper-label" className='dob_select_dropdown'
                      id="month"
                      name="month"
                      value={month}
                      displayEmpty
                      onChange={(event)=>setMonth(event.target.value)}
                      autoWidth
                      MenuProps={MenuProps}
                    >
                      <MenuItem  value='' disabled><Typography variant="p">Month</Typography></MenuItem>
                      {birthdataData[1]['month'].map((item) =>
                        <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                      )}  
                      
                    </Select>
                  
                  </FormControl>
                  </Grid>
                  <Grid item md={4}>
                    <FormControl fullWidth className='formControl dob_input'>
                      {/* <label>Year*</label> */}
                    <Select labelId="demo-simple-select-helper-label" className='dob_select_dropdown'
                        id="year"
                        name="year"
                        value={year}
                        displayEmpty
                        
                        onChange={(event)=>setYear(event.target.value)}
                        autoWidth
                        MenuProps={MenuProps}
                      >
                        <MenuItem  value='' disabled><Typography variant="p">Year</Typography></MenuItem>
                          {birthdataData[2]['year'].map((item) =>
                        <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                      )}  
                      </Select>
                    </FormControl>
                    
                  </Grid>
                  <Grid item md={12}>
                    {!!birthdateError &&
                      // <p className="error_msg">{birthdateError}</p> 
                      <FormHelperText className="Mui-error">{birthdateError}</FormHelperText>
                    }
                  </Grid>
                </Grid>
              </Grid>
                <Grid item md={6}>
                  <FormControl fullWidth className='formControl'>
                    <label>Password*</label>
                    <TextField
                      autoComplete="none"
                      required
                      fullWidth
                      name="password"
                      type={values.showPassword ? "text" : "password"}
                      id="password"
                      helperText={passwordError}
                      error={!!passwordError}
                      value={values.password}
                      onChange={(event)=>setValues({...values, password:event.target.value })}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {values.showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        )
                    
                    }}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  <FormControl fullWidth className='formControl'>
                    <label>Confirm password*</label>
                    {/* <TextField required fullWidth type="password" hinttext="Password" floatinglabeltext="Password" id="password" autoComplete="none" /> */}
                    <TextField
                      autoComplete="none"
                      required
                      fullWidth
                      name="confirmpassword"
                      type={values.showConfirmPassword ? "text" : "password"}
                      id="confirmpassword"
                      helperText={confirmPasswordError}
                      error={!!confirmPasswordError}
                      value={values.confirmPassword}
                      onChange={(event)=>setValues({...values, confirmPassword:event.target.value })}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowConfirmPassword}
                              onMouseDown={handleMouseDownConfirmPassword}
                            >
                              {values.showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        )
                    
                    }}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={12}>

  
                <FormHelperText className='password_note'>Note: The password should be atleast 8 characters long</FormHelperText>

                    </Grid>
              
                
                
                    <Grid item md={6}>
                  <FormControl fullWidth className='formControl gender_dropdown'>
                    <label>Gender*</label>
                    {/* <RadioGroup defaultValue="male" row aria-label="gender" name="row-radio-buttons-group">
                        <FormControlLabel value="male" name="gender" control={<Radio size="small"  />} label="Male" />
                        <FormControlLabel name="gender" value="female" control={<Radio size="small"  />} label="Female" />
                    </RadioGroup> */}
                    <Select labelId="demo-simple-select-helper-label"
                      id="gender"
                      name="gender"
                      value={gender}
                      displayEmpty
                      onChange={(event)=>setGender(event.target.value)}
                      autoWidth
                      MenuProps={MenuProps}
                    >
                      {/* <MenuItem key='selectgender' value="selectgender" selected>Select</MenuItem> */}
                      <MenuItem  value='' disabled><Typography variant="p">Select </Typography></MenuItem>
                      <MenuItem key='male' value="male">Male</MenuItem>
                      <MenuItem key='female' value='female'>Female</MenuItem>
                     
                      {/* {!!genderError &&
                            <FormHelperText className="Mui-error">{genderError}</FormHelperText>
                            } */}
                           
                    </Select>
                     {genderError !='' &&
                            <FormHelperText className="Mui-error">{genderError}</FormHelperText>
                            }
                    {/* <FormHelperText className="Mui-error">{genderError}</FormHelperText> */}
                  </FormControl>
                </Grid>
               
                {/* <Grid item md={12}>
                  <FormControl fullWidth className='formControl'>
                    <label>Country*</label>
                    <Autocomplete
                      id="country-select-demo"
                      // sx={{ width: 300 }}
                      value={selCountry}
                      options={countryData}
                      autoHighlight
                      disableClearable
                      getOptionLabel={(option) => option.name}
                      onChange={(event, newValue) => {
                        handleChangeCountry(newValue);
                      }}
                      renderOption={(props, option) => (
                        <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                          {option.emoji}&nbsp;&nbsp; (+{option.phone_code}) {option.name}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder='Select'
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'new-password', // disable autocomplete and autofill
                          }}
                          error={!!countryError}
                          id="country"
                          name="country"
                        />
                      )}
                    />
                    {!!countryError &&
                      <FormHelperText className="Mui-error">{countryError}</FormHelperText>
                    }
                  </FormControl>
                </Grid> 
                <Grid item md={12}>
                  <FormControl fullWidth className='formControl'>
                    <label>State*</label>
                    <Autocomplete
                      id="state-select-demo"
                      // sx={{ width: 300 }}
                      value={selState}
                      options={stateList}
                      autoHighlight
                      disableClearable
                      getOptionLabel={(option) => option.name}
                      onChange={(event, newValue) => {
                        handleChangeState(newValue);
                      }}
                      renderOption={(props, option) => (
                        <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} key={option.id} {...props}>
                          {option.name}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder='Select'
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'new-password', // disable autocomplete and autofill
                          }}
                          error={!!stateError} 
                          id="state"
                          name="state"
                        />
                      )}
                    />
                    {!!stateError &&
                      <FormHelperText className="Mui-error">{stateError}</FormHelperText>
                    }
                  </FormControl>
                </Grid>
                <Grid item md={12}>
                  <FormControl fullWidth className='formControl'>
                    <label>City*</label>
                    <Autocomplete
                      id="city-select-demo"
                      // sx={{ width: 300 }}
                      value={city}
                      options={cityList}
                      autoHighlight
                      disableClearable
                      getOptionLabel={(option) =>option.name != undefined ? option.name : ""}
                      onChange={(event, newValue) => {
                        handleChangeCity(newValue);
                      }}
                      renderOption={(props, option) => (
                        <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} key={option.id} {...props}>
                          {option.name}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder='Select'
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'new-password', // disable autocomplete and autofill
                          }}
                          error={!!cityError}
                          id="city"
                          name="city"
                        />
                      )}
                    />
                    {!!cityError &&
                      <FormHelperText className="Mui-error">{cityError}</FormHelperText>
                    }
                  </FormControl>
                </Grid>*/}

                <Grid item md={6}>
                  <FormControl fullWidth className='formControl gender_dropdown'>
                    <label>I am a </label>
                    
                    <Select labelId="demo-simple-select-helper-label"
                      id="usertype"
                      name="usertype"
                      value={userType}
                      displayEmpty
                      onChange={(event)=>setUsertype(event.target.value)}
                      autoWidth
                      MenuProps={MenuProps}
                    >
                      {userTypedata.map((item) =>
                        <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                      )}    
                    </Select>
                    
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  <FormControl fullWidth className='formControl'>
                    <label>Referral code (optional)</label>
                    <TextField
                      required
                      autoComplete="none"
                      fullWidth
                      id="referralcode"
                      name="referralcode"
                      value={referralcode}
                      onChange={(event)=>setReferralcode(event.target.value)}
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Grid item md={12} className='terms_policy'>
                <Typography variant="p">By clicking Create account, I agree that:</Typography>
                <ul>
                  <li>I have read and accepted the <Link href={appLink+"terms-of-service/"} >Terms of Use.</Link></li>
                  <li>See our <Link href={appLink+"privacy-policy/"} >Privacy Policy</Link> for more details or to opt-out at any time.</li>
                </ul>
              </Grid>
              <Grid container className='forgot_or_register_option'>
                <Grid item md={5}><Button type="submit" className='default_btn'>Create account</Button></Grid>
                {/* <Grid item md={5}><Button onClick={goBackOTP} className='default_btn'>otpshow</Button></Grid> */}
                {/* <Grid item md={7}><p>Already have an account? <Link href="/login">Sign in</Link></p></Grid> */}
              </Grid>
              </Box>
            </Grid>
            <Grid item md={6} className='bannersection'>
              {refImage && <img className='loginBanner' src={refImage} title="Login Banner" alt='Login Banner'/>}
              {refMessage && <p>{refMessage}</p>}
            </Grid>
          </Grid>
      }
      {/* {authenticationState.showOtpScreen===true &&
      <Grid container spacing={2} className='loginScreen loginOTPScreen'>
      <Grid item md={6} className='formsection'>
          <Box component="form" noValidate onSubmit={handleSubmitOtp}>
            <Link href={appLink} ><img src={Logo} title="MySphere" alt='MySphere' className='logo2'/></Link>
            <h1>Email Verification</h1>
            <p>Enter the verification code sent to <strong>{email}</strong> <br></br>If you don't see it, check your spam folder</p>
            {socialEmail=='' &&
              <>
                  <div className="otp_verification_wrap_main_reg">
                    <div className="otp_verification_wrap">
                      <FormControl fullWidth className='formControl'>
                        <TextField
                          required
                          autoComplete="none"
                          fullWidth
                          id="emailOTP"
                          name="emailOTP"
                          type="text"
                          // type="number"
                          definitions={{
                            '#': /[1-9]/,
                          }}
                          helperText={emailOTPError}
                          error={!!emailOTPError}
                          // placeholder="Type the code received on your email here"
                          inputProps={{ maxLength : 6 }}
                          className="otp_verification_input"
                        />
                      </FormControl>
                    </div>
                    {secondsEmail == false ?<span className='otpTimeResend'><img src={OTPTime} alt="OTPTime"/> 00:{seconds} </span>
                      :null}
                    {secondsEmail == true ?
                      <span className='otpTimeResend'><strong><Button className="resendotp_btn" onClick={resend_Email_otp}>Resend OTP</Button></strong></span>
                      :null}
                  </div>
                 
                </>
              }
            <Grid container className='forgot_or_register_option'>
              <Grid item md={12} className='form_buttons'>
                <Button className='default_btn_border'sx={{ mr:1 }} type="button" onClick={()=>goBackRegistration()}>Go Back</Button>
                <Button type="submit" className='default_btn'>Verify &amp; Proceed</Button>
              </Grid>
             
            </Grid>
            </Box>
      </Grid>
      <Grid item md={6} className='bannersection'>
        <img className='loginBanner' src={otpBanner} title="Login Banner" alt='Login Banner'/>
      </Grid>
      </Grid>
      } */}
      {authenticationState.showParentalScreen === true &&
        <ParentalConsent countryCode={countryCode} 
        onSubmitForm={(parentName,parentEmail,parentMobile)=>handleSubmitParental(parentName,parentEmail,parentMobile)} 
        onSkipForm={(parentName,parentEmail,parentMobile,skipParental)=>handleSubmitParental(parentName,parentEmail,parentMobile,skipParental)} userEmail={email} userMobile={mobile} />
      }
    </div>
    </body>
  );
}

export default Register;